import React from "react";
import { Modal, Button } from "react-bootstrap";
import AppForm from "./AppForm";
import { useAppForm } from "../../hooks/Dashboard/Apps/useAppForm";
import "../../assets/css/Apps/AppModal.css";
import { useDispatch } from "react-redux";
import { fetchApps } from "../../store/slices/appSlice";

const AppModal = ({ isOpen, onClose, mode, initialData = null }) => {
  const dispatch = useDispatch();
  const isEdit = mode === "edit";
  const { formik, isSubmitting, submitForm } = useAppForm(initialData, isEdit);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await submitForm();
    if (success) {
      await dispatch(fetchApps(true));
      onClose();
    }
  };

  const getSubmitButtonLabel = () => {
    if (isSubmitting) {
      return isEdit ? "Updating..." : "Creating...";
    }
    return isEdit ? "Update App" : "Create App";
  };

  return (
    <Modal show={isOpen} onHide={onClose} size="lg" centered className="modal">
      <Modal.Header closeButton className="modalHeader">
        <Modal.Title className="modalTitle">
          {isEdit ? `Edit App: ${initialData?.station_name}` : "Add New App"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="modalBody">
        <AppForm formik={formik} isSubmitting={isSubmitting} />
      </Modal.Body>

      <Modal.Footer className="modalFooter">
        <Button variant="secondary" onClick={onClose} className="cancelButton">
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={
            isSubmitting || !formik.isValid || (!isEdit && !formik.dirty)
          }
          className="submitButton"
        >
          {getSubmitButtonLabel()}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AppModal;
